import React from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Button} from "primereact/button";
import {Badge} from "primereact/badge";

const CandidateLanguageListComponent = (props) => {

  const history = useHistory();
  const {id} = useParams();
  const languages = props.languages || [];

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {localStorage.getItem('roles').toString().includes('role_') &&
          <Button icon="pi pi-pencil" className="p-button-warning p-button-sm p-mr-2"
                  tooltip={props.t('edit')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    history.push(`/recruitment/candidate/read/${id}?update=candidate-language&candidateLanguageId=${rowData.id}&candidateId=${id}`)
                  }}/>
        }
      </React.Fragment>
    );
  }

  const renderCard = (rowData) => (
    <div key={rowData.id} className="p-card p-shadow-none p-mb-2" style={{overflow: 'hidden'}}>
      <div className="p-p-3 p-d-flex p-jc-between p-ai-start p-flex-wrap" style={{gap: '1rem'}}>
        <div className="p-d-flex p-flex-column" style={{gap: '0.85rem', flex: '1 1 240px'}}>
          <div className="p-d-flex p-ai-center p-flex-wrap" style={{gap: '0.5rem'}}>
            <span style={{display: 'inline-block'}}>
              <Badge value={rowData?.level || props.t('noLevel')} severity="info" rounded />
            </span>
              <span className="p-text-bold">{rowData?.language?.name || props.t('noLanguageProvided')}</span>
          </div>
        </div>
        <div className="p-d-flex p-ai-start">
          {actionBodyTemplate(rowData)}
        </div>
      </div>
    </div>
  )

  return (
    <>
      <div className="p-d-flex p-flex-column">
        {languages.length > 0 ? languages.map(renderCard) : (
          <div className="p-py-2 p-text-secondary">
            {props.t('noResults')}
          </div>
        )}
      </div>
    </>
  )
}
export default withTranslation('common')(CandidateLanguageListComponent);
